import React, { Component } from "react";
import "./style.scss";
import { Helmet } from "react-helmet";

class Cv extends Component {
  render() {
    return (
      <div className="page Cv">
        <Helmet>
          <title>Tanguy HELLER | CV</title>
        </Helmet>

        <div className="pdf-wrapper">
          <iframe
            src="/CV_V1.pdf#view=FitH"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>
    );
  }
}

export default Cv;
